import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode  } from '@fortawesome/free-solid-svg-icons';
import { FormatHelper } from '../../../helpers/FormatHelper';
import { CollectTrackingItem } from '../../../models/CollectTrackingItem';
import { ErpNfe } from '../../../models/ErpNfe';
import { CarrierStatusTracking } from '../../../models/CarrierStatusTracking';
import { ProfileType } from '../../../enums/ProfileType';
import { CollectTrackingResultType } from '../../../enums/CollectTrackingResultType';
import ServicesContext from '../../../contexts/ServicesContext';
import { useAuth } from '../../../contexts/AuthContext';
import { GetOrderAddressesOutput } from '../../../services/Orders/GetOrderAddresses/GetOrderAddressesOutput';
import { ManageTransportHelper } from '../../../helpers/ManageTransportHelper';
import { ExternalLink } from '../../../common-components/ExternalLink/ExternalLink';
import { Container, StatusContainer, StatusContent, TableData, TableDocument, TableHeaderTitle, TrackingCodeChangeButton } from './styles';

interface ICardCollectTrackingItemProps {
  orderNumber?: string;
  shippingLineCode?: string;
  collectTrackingItem: CollectTrackingItem;
  erpNFe?: ErpNfe;
  orderAddresses?: GetOrderAddressesOutput|null;
  carrierStatusTrackingList?: CarrierStatusTracking[];
  changeTrackingCode?: (collectTrackingItemId: number, trackingCode: string) => void;
}

const CardCollectTrackingItem: React.FC<ICardCollectTrackingItemProps> = ({
  orderNumber,
  shippingLineCode,
  collectTrackingItem,
  erpNFe,
  orderAddresses,
  carrierStatusTrackingList,
  changeTrackingCode
}) => {

  const {session} = useAuth();
  
  const {
    alertService
  } = React.useContext(ServicesContext);

  const documentNumber = ManageTransportHelper.getDocumentNumber(erpNFe, orderAddresses);
  const documentOnlyNumbers = documentNumber?.replace(/\D+/g, '');
  const trackingCode = collectTrackingItem?.trackingKeyList?.find(tk => tk.name == 'KeyNfe')?.value;
  const externalLink = ManageTransportHelper.getExternalLink(
          shippingLineCode, erpNFe?.keyNfe, orderNumber, erpNFe?.nfeNumber, trackingCode, 
          collectTrackingItem?.billCode, documentOnlyNumbers ?? '');

  return (
    <Container>
      <TableDocument>
        <thead>
          <tr>
            <TableHeaderTitle>
              <span>NF-e / Código Rastreio</span>
              {session?.user?.profileType == ProfileType.Admin ? (
                <TrackingCodeChangeButton title='Código Rastreio' onClick={() => {
                  alertService.queryInputText('Código de Rastreio', trackingCode || '', '', 'Trocar Código').then((queryResult) => {
                    if (!queryResult.isConfirmed) return;
                    const newTrackingCode = queryResult?.value?.trim() || '';
                    if (!newTrackingCode) {
                      alertService.info('Informe o código de rastreio.');
                      return;
                    }
                    if (newTrackingCode == trackingCode) {
                      alertService.info('Informe um código de rastreio diferente do atual.');
                      return;
                    }
                    alertService.confirm('Deseja realmente trocar o código de rastreio?').then((confirmResult) => {
                      if (confirmResult.isConfirmed && changeTrackingCode) {
                        changeTrackingCode(collectTrackingItem.id, newTrackingCode);
                      }
                    });
                  });
                }}>
                  <FontAwesomeIcon icon={faBarcode} color='#c26c0a' size='1x' />
                </TrackingCodeChangeButton>
              ) : null}
            </TableHeaderTitle>
            <TableHeaderTitle width='116px'>
              CPF/CNPJ
            </TableHeaderTitle>
            <TableHeaderTitle width='25px'></TableHeaderTitle>
          </tr>
        </thead>
        <tbody>
          <tr>
            <TableData>
              {erpNFe?.keyNfe} {trackingCode && trackingCode != erpNFe?.keyNfe ? ` / ${trackingCode}` : ''}
            </TableData>
            <TableData>
              {documentNumber || '(vazio)'}
            </TableData>
            <TableData>
              <ExternalLink link={externalLink} />
            </TableData>
          </tr>
        </tbody>
      </TableDocument>
      <StatusContainer>
        {collectTrackingItem.promisedDate ? (
          <StatusContent contentColor='#000' withBorderBottom={true}>
            <div>Data de promessa</div>
            <div>{FormatHelper.formatDateTime(collectTrackingItem.promisedDate)}</div>
          </StatusContent>
        ) : null}
        {!collectTrackingItem.collectTrackingItemStatusLogs || collectTrackingItem.collectTrackingItemStatusLogs.length === 0 ? (
          <>
          <StatusContent>
            Este pacote ainda não possui status.
          </StatusContent>
          {collectTrackingItem.resultDetails ? (
            <StatusContent contentColor={collectTrackingItem.collectTrackingResultType == CollectTrackingResultType.Failed ? '#c51d1d' : '#035503'}>
            {collectTrackingItem.resultDetails}
            </StatusContent>
          ) : null}
          </>
        ) : (
          collectTrackingItem.collectTrackingItemStatusLogs?.map((statusLog, logIndex) => {
            const carrierStatusTracking = carrierStatusTrackingList?.find(cst => cst.id == statusLog.carrierStatusTrackingId);
            let color = 'inherit';
            if (carrierStatusTracking?.isProblem) {
              color = '#c51d1d';
            } else if (carrierStatusTracking?.isTerminal) {
              color = '#035503';
            }
            console.log('carrierStatusTracking:', carrierStatusTracking);
            return (
              <StatusContent key={`collect-tracking-item-status-log-${statusLog.id}`} withBorderTop={logIndex>0} contentColor={color}>
                <div style={{maxWidth: '80%'}}>{statusLog.statusDescription}</div>
                <div>{FormatHelper.formatDateTime(statusLog.statusDate)}</div>
              </StatusContent>
            );
          })
        )}
      </StatusContainer>
    </Container>
  );

}

export {CardCollectTrackingItem};